import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Text } from "@frontend/ui-kit/Text";
import { TextField } from "@frontend/ui-kit/TextField";
import { useEffect, useRef, useState } from "react";
import { canv } from "@/canv/global";
import { checkLinkForEmbed } from "@/elements/embed/utils";
import { Modal } from "@/interface/ui/Modal";
import { Button } from "@/shared/ui/Button";
import styles from "./CreateEmbedModal.module.css";
import GoogleIcon from "./icons/Google.svg?react";
import MTSLinkIcon from "./icons/MTS Link.svg?react";
import R7Icon from "./icons/R7.svg?react";
import RutubeIcon from "./icons/RuTube.svg?react";

const EMBED_SERVICES = [
    {
        title: "MTS Link",
        icon: MTSLinkIcon,
    },
    // {
    //     title: "My Office",
    //     icon: MyOfficeIcon,
    // },
    {
        title: "R7",
        icon: R7Icon,
    },
    {
        title: "Rutube",
        icon: RutubeIcon,
    },
    {
        title: "Google",
        icon: GoogleIcon,
    },
];

type CreateEmbedModalProps = {
    defaultValue: string;
};

export const CreateEmbedModal = NiceModal.create<CreateEmbedModalProps>(({ defaultValue = "" }) => {
    const modal = useModal();
    const onClose = () => {
        modal.resolve();
        modal.hide();
        modal.remove();
    };
    const [link, setLink] = useState(defaultValue);
    const hasError = !checkLinkForEmbed(link.trim());

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLink(e.target.value);
    };

    const handleSubmit = () => {
        if (!link) {
            return;
        }
        if (!checkLinkForEmbed(link)) {
            return;
        }
        modal.resolve(link);
        onClose();
    };

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!inputRef.current) {
            return;
        }
        const handleFocus = () => {
            canv.appInterface.inputFocused = 1;
        };
        const handleBlur = () => {
            canv.appInterface.inputFocused = 0;
        };
        inputRef.current.addEventListener("focus", handleFocus);
        inputRef.current.addEventListener("blur", handleBlur);
        return () => {
            inputRef.current?.removeEventListener("focus", handleFocus);
            inputRef.current?.removeEventListener("blur", handleBlur);
        };
    }, []);

    return (
        <Modal onClose={onClose}>
            <div className={styles.headerText}>
                <Text size="xl" align="center">
                    Встраиваемый контент
                </Text>
                <Text size="m" align="center" className={styles.headerSubText}>
                    Вставьте ссылку на контент из внешних источников и отображайте его на доске
                </Text>
            </div>
            <form onSubmit={handleSubmit}>
                <TextField
                    type="text"
                    label="Ссылка"
                    onChange={handleChange}
                    value={link}
                    errorMessage={
                        Boolean(link) && hasError
                            ? "URL-адрес который вы пытаетесь отправить недействителен"
                            : null
                    }
                    ref={inputRef}
                />
                <Button className={styles.submit} fullWidth type="submit" disabled={hasError}>
                    Добавить на доску
                </Button>
            </form>
            <div className={styles.bottom}>
                <Text align="center" className={styles.bottomText}>
                    Поддерживаемые сервисы:
                </Text>
                <ul className={styles.services}>
                    {EMBED_SERVICES.map(({ title, icon: Icon }) => {
                        return (
                            <li key={title} title={title} className={styles.service}>
                                <Icon />
                            </li>
                        );
                    })}
                </ul>
            </div>
        </Modal>
    );
});
